import { onBeforeUnmount } from 'vue';
import { debounce } from 'lodash';

export default function () {
    let stickyEl = null;
    let onScroll = null;

    const setStickyRef = element => {
        stickyEl = element;

        if (!stickyEl) {
            return;
        }

        // scroll handler debounced
        onScroll = debounce(() => {
            const topOffset = parseInt(getComputedStyle(stickyEl).top, 10) || 0;
            const stickyOffset = parseInt(stickyEl.getBoundingClientRect().top, 10);

            stickyEl.classList.toggle('is-stuck', stickyOffset <= topOffset);
        }, 10);

        window.addEventListener('scroll', onScroll, { passive: true });

        onScroll();
    }

    onBeforeUnmount(() => {
        if (onScroll) {
            window.removeEventListener('scroll', onScroll);
        }
    });

    return {
        setStickyRef,
    }
}
